import React from 'react';
import PropTypes from 'prop-types';
import TextFieldGroup from '../common/TextFieldGroup';
import { connect } from 'react-redux';
import { login } from '../../actions/authActions';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

function validateInput(data) {
  let errors = {};

  if (!Validator.isEmail(data.login) && data.login !== 'demo') {
    errors.login = 'Неверный формат';
  }

  if (Validator.isEmpty(data.pass)) {
    errors.pass = 'Это обязательное поле';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}


class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      pass: '',
      errors: {},
      isLoading: false
    };
  }

  isValid = () => {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  onSubmit = e => {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      const toSend = {login:this.state.login,pass:this.state.pass};
      this.props.login(toSend, errors => {
        if(errors) {
          this.setState({ errors, isLoading: false });
          return;
        }
        this.context.router.push('/order');
      });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { errors, login, pass, isLoading } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <h1>Вход в систему</h1>

        { errors.form && <div className="alert alert-danger">{errors.form}</div> }

        <TextFieldGroup
          autoFocus={true}
          field="login"
          label="Email"
          value={login}
          error={errors.login}
          onChange={this.onChange}
        />

        <TextFieldGroup
          field="pass"
          label="Пароль"
          value={pass}
          error={errors.pass}
          onChange={this.onChange}
          type="password"
        />

        <div className="form-group"><button className="btn btn-primary btn-lg" disabled={isLoading}>Войти</button></div>
      </form>
    );
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired
}

LoginForm.contextTypes = {
  router: PropTypes.object.isRequired
}

export default connect(null, { login })(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js